import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { SmartForm } from 'components';
import { valueToInteger } from 'utils';
import { saveSetting, getSetting } from 'rdx/config';

import saleSchema from './saleSchema';

import './saleOptions.scss';

function SaleOptions() {
  const dispatch = useDispatch();
  const saleOptionsRef = React.useRef(null);

  const uiPreviousConfig = useSelector(getSetting('touchpos_ui_configuration'));

  const [prevSettings, setPrevSettings] = useState({});
  const [uiSettingsState, setUISettings] = useState({});

  useEffect(() => {
    if (uiPreviousConfig) {
      const settingsObject = JSON.parse(uiPreviousConfig);
      setUISettings({ ...settingsObject });
    }
  }, [uiPreviousConfig]);

  useEffect(() => {
    setPrevSettings({
      ...uiSettingsState,
    });
  }, [uiSettingsState]);

  const submitSetting = () => {
    const { values } = saleOptionsRef.current;

    const prevUIConfig = uiPreviousConfig ? JSON.parse(uiPreviousConfig) : {};
    const newUISettings = { ...prevUIConfig };

    Object.entries(values).forEach(([key, value]) => {
      newUISettings[key] = valueToInteger(value);
    });

    dispatch(
      saveSetting({
        parameterName: 'touchpos_ui_configuration',
        parameterValue: JSON.stringify(newUISettings),
      }),
    );
  };

  return (
    <SmartForm
      grid
      autosave
      ref={saleOptionsRef}
      fields={saleSchema}
      handleSubmit={submitSetting}
      state={prevSettings}
    />
  );
}

export default SaleOptions;
